

































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import Add from "./broadcast_add.vue";

@Component({
  components: {
    Add
  }
})
export default class extends Mixins(MyList) {
  @Prop() stadiumId!: number;

  dispatchType = "stadium/customaudioplay";

  columns: any[] = [
    { title: "广播内容", scopedSlots: { customRender: "content" } },
    { title: "广播时间", dataIndex: "created_time" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  again(id: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: "确定再播一次吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/againcustomaudioplay", {
          id
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success(res.Message);
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  mounted() {
    this.loadData({ stadium_id: this.stadiumId }, false);
  }
}
